export const convertPxToPoint = (px: number) => 0.7 * px;
